// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "传热学",
        "tec": "卫运钢",
        "week": "1-12周",
        "add": "教学楼B座322能动"
      },
      {
        "sub": "劳动与创造",
        "tec": "王超",
        "week": "14周",
        "add": "教学楼C座213教务"
      }
    ],
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "黄颖娜",
        "week": "1-8周",
        "add": "教学楼C座213教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "王超",
        "week": "14周",
        "add": "教学楼C座213教务"
      }
    ],
    0,
    {
      "sub": "就业创业指导",
      "tec": "朱旭",
      "week": "1-4周",
      "add": "教学楼C座303教务"
    },
    0
  ],
  "2": [
    {
      "sub": "核岛系统与设备",
      "tec": "李伟哲",
      "week": "1-12周",
      "add": "教学楼B座322能动"
    },
    {
      "sub": "核反应堆物理",
      "tec": "周文平",
      "week": "1-12周",
      "add": "教学楼B座322能动"
    },
    0,
    {
      "sub": "国家安全教育",
      "tec": "黄颖娜",
      "week": "1,4-5,7周",
      "add": "教学楼C座115教务"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "核电子学与核辐射探测",
        "tec": "覃国秀",
        "week": "1-12周",
        "add": "教学楼B座422能动"
      },
      {
        "sub": "劳动与创造",
        "tec": "王超",
        "week": "14周",
        "add": "教学楼C座111教务"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "王超",
      "week": "14周",
      "add": "教学楼C座111教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "传热学",
      "tec": "卫运钢",
      "week": "1-12周",
      "add": "教学楼B座322能动"
    },
    {
      "sub": "核岛系统与设备",
      "tec": "李伟哲",
      "week": "1-12周",
      "add": "教学楼B座423能动"
    },
    0,
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "黄颖娜",
      "week": "1-8周",
      "add": "教学楼C座213教务"
    },
    0
  ],
  "5": [
    {
      "sub": "核反应堆物理",
      "tec": "周文平",
      "week": "1-12周",
      "add": "教学楼B座322能动"
    },
    {
      "sub": "核电子学与核辐射探测",
      "tec": "覃国秀",
      "week": "1-12周",
      "add": "教学楼B座322能动"
    },
    {
      "sub": "国家安全教育",
      "tec": "黄颖娜",
      "week": "1,4-5,7周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "工程伦理",
      "tec": "金钰刘洪抵",
      "week": "1-8周",
      "add": "教学楼B座324能动"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
